export default __webpack_public_path__ + "static/media/Public sector.9e3166f9.svg";